var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('d-header',{attrs:{"fluid":""}},[_c('h1',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t("works_list"))+"\n    ")])]),_vm._v(" "),_c('v-works-table',{attrs:{"show-property":"","show-filters":"","searchable":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }